import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',
  // Whole-pixel width: iOS WebKit skips painting the left/right edges of a
  // dashed border when the width is fractional (2.5px) — PFM-2682.
  border: `2px dashed ${theme.palette.divider}`,
  boxSizing: 'border-box',
  overflow: 'auto',
}));

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '48px',
  color: theme.palette.text.secondary,
  gap: '6px',
}));

export const FilesContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});
